__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => typeof console !== "undefined" && console.warn && console.warn(msg);;
	var uniqueName = "vimeography-admin";
	var register = (name, version, factory) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || !activeVersion.loaded && uniqueName > activeVersion.from) versions[version] = { get: factory, from: uniqueName };
	};
	var initExternal = (id) => {
		var handleError = (err) => warn("Initialization of sharing external failed: " + err);
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => module && module.init && module.init(__webpack_require__.S[name], initScope)
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("react-dom", "17.0.1", () => Promise.all([__webpack_require__.e(935), __webpack_require__.e(212), __webpack_require__.e(418)]).then(() => () => __webpack_require__(3935)));
			register("react-query", "3.5.11", () => Promise.all([__webpack_require__.e(767), __webpack_require__.e(192)]).then(() => () => __webpack_require__(8767)));
			register("react-router-dom", "5.2.0", () => Promise.all([__webpack_require__.e(338), __webpack_require__.e(962), __webpack_require__.e(320)]).then(() => () => __webpack_require__(3338)));
			register("react", "17.0.1", () => __webpack_require__.e(976).then(() => () => __webpack_require__(7294)));
			initExternal(1483);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => initPromises[name] = 1);
};